export default class OrganizationAppInvitationHistory {
  constructor(API) {
    this.api = API;
  }
  async getOrgAppInvitationHistory(orgID, reverseOrder) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/organization/${orgID}/app/invitation/history`;
    req.appendQueryParam('reverseOrder', reverseOrder);
    return await req.exec();
  }
  async getOrgAppInvitationHistoryByStatus(orgID, status) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/organization/${orgID}/app/invitation/status/${status}`;
    return await req.exec();
  }
}
